import { render, staticRenderFns } from "./QueryRoots.vue?vue&type=template&id=0a567250&scoped=true&"
import script from "./QueryRoots.vue?vue&type=script&lang=js&"
export * from "./QueryRoots.vue?vue&type=script&lang=js&"
import style0 from "./QueryRoots.vue?vue&type=style&index=0&id=0a567250&lang=scss&scoped=true&"
import style1 from "./QueryRoots.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a567250",
  null
  
)

export default component.exports